import React, { useState } from 'react';
import AdminSubPage from '../components/AdminSubPage';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { officesApi } from '../lib/api';
import { toast } from 'sonner';

const MigrateBalancesPage = () => {
  const [offices, setOffices] = useState([]);
  const [form, setForm] = useState({ office_id: '', as_of_date: '' });
  React.useEffect(() => { officesApi.list().then(r => setOffices(r.data)).catch(console.error); }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Opening balances migration initiated');
  };

  return (
    <AdminSubPage title="Migrate Opening Balances (Office-wise)" breadcrumb={['Accounting', 'Migrate Opening Balances']} backPath="/dashboard/accounting">
      <form onSubmit={handleSubmit} className="bg-white border border-gray-200 p-6 max-w-md space-y-4">
        <p className="text-sm text-gray-500">Migrate opening balances for a specific office from a legacy system.</p>
        <div><Label>Office *</Label>
          <Select value={form.office_id} onValueChange={v => setForm({...form, office_id: v})}>
            <SelectTrigger data-testid="mb-office"><SelectValue placeholder="Select Office" /></SelectTrigger>
            <SelectContent>{offices.map(o => <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div><Label>As Of Date *</Label><Input type="date" value={form.as_of_date} onChange={e => setForm({...form, as_of_date: e.target.value})} required data-testid="mb-date" /></div>
        <Button type="submit" className="bg-[#1f1f1f] text-white" data-testid="mb-submit">Migrate</Button>
      </form>
    </AdminSubPage>
  );
};
export default MigrateBalancesPage;
